import type React from 'react'

import { PlaceSearchFailureProvider } from './contexts/PlaceSearchFailureContext'
import { PromptManagementProvider, type PromptManagementContextValue } from './contexts/PromptManagementContext'
import { TripPlannerChatProvider, type TripPlannerChatProviderProps } from './contexts/TripPlannerChatProvider'
import { TripPlannerEventBusProvider } from './contexts/TripPlannerEventBus'

export interface TripChatRuntimeProps extends Omit<TripPlannerChatProviderProps, 'children'> {
  promptContextValue: PromptManagementContextValue
  children: React.ReactNode
}

function TripChatRuntime({ promptContextValue, children, ...chatProviderProps }: TripChatRuntimeProps) {
  return (
    <PromptManagementProvider value={promptContextValue}>
      <TripPlannerEventBusProvider>
        <PlaceSearchFailureProvider>
          <TripPlannerChatProvider {...chatProviderProps}>
            {children}
          </TripPlannerChatProvider>
        </PlaceSearchFailureProvider>
      </TripPlannerEventBusProvider>
    </PromptManagementProvider>
  )
}

export default TripChatRuntime
